import { Typography, Box, TextField } from '@mui/material';
import { useState, useEffect, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import apiReq from 'core/api';

export default function CustomPrompt({ isDisabled = false }) {
  const currProject = useSelector((state) => state.reducer.project.id);

  const [text, setText] = useState('');
  const [savedStatus, setSavedStatus] = useState(null);
  const statusTimerRef = useRef(null);

  const getData = useCallback(() => {
    apiReq(`projects/custom-generation-prompt?project_id=${currProject}`, 'get').then((res) => {
      setText(res.custom_prompt);
    });
  }, [currProject]);

  useEffect(() => {
    if (currProject) {
      getData();
    }
  }, [currProject, getData]);

  const timerRef = useRef(null);

  const changeText = (value) => {
    setText(value);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      apiReq(`projects/custom-generation-prompt?project_id=${currProject}`, 'post', {
        custom_prompt: value,
      })
        .then(() => {
          setSavedStatus('saved');
          if (statusTimerRef.current) clearTimeout(statusTimerRef.current);
          statusTimerRef.current = setTimeout(() => setSavedStatus(null), 3000);
        })
        .catch(() => {
          setSavedStatus('error');
          if (statusTimerRef.current) clearTimeout(statusTimerRef.current);
          statusTimerRef.current = setTimeout(() => setSavedStatus(null), 3000);
        });
    }, 1000);
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      if (statusTimerRef.current) {
        clearTimeout(statusTimerRef.current);
      }
    };
  }, []);

  return (
    <>
      {currProject && (
        <>
          <Box style={{ padding: '16px', position: 'relative' }}>
            <TextField
              multiline
              rows={5}
              fullWidth
              variant="outlined"
              placeholder="Например: Удали секцию геймификации и добавь интеграцию с VK"
              value={text}
              disabled={isDisabled}
              onChange={(e) => changeText(e.target.value)}
            />
            {savedStatus === 'saved' && (
              <Box sx={{ position: 'absolute', right: 15, bottom: -10 }}>
                <Typography variant="body2" color="success.main" align="center">
                  Сохранено
                </Typography>
              </Box>
            )}
            {savedStatus === 'error' && (
              <Box sx={{ position: 'absolute', right: 15, bottom: -10 }}>
                <Typography variant="body2" color="error.main" align="center">
                  Ошибка
                </Typography>
              </Box>
            )}
          </Box>
        </>
      )}
    </>
  );
}
